import type { variants } from 'components/pagesComponents/user/OfferPage/constants';

const pageUrls = {
  home: '/',
  auth: '/auth/signin/',
  registration: '/auth/registration/',
  resetPassword: '/auth/reset-password/',
  onboarding: '/user/onboarding/',
  plans: '/payments/plans/main/',
  paymentHistory: '/payment-history',
  profileSubscription: '/profile/subscription',
  plansGroup: (group: string): string => {
    return `/payments/plans/${group}/`;
  },
  privacy: 'https://welltory.com/privacy/',
  terms: 'https://welltory.com/terms/',
  authCallback: '/auth/auth-callback',
  offer: (variant?: keyof typeof variants): string => {
    if (variant) {
      return `/user/offer/?variant=${variant}`;
    }

    return '/user/offer/';
  },
};

export default pageUrls;
